import { useMutation } from '@apollo/client/react';
import { Row, Space } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import events from '@guuru/events-web';
import { Emoji } from '@guuru/react-emoji';
import RATE_EXPERT from './mutations/PreRateChat';
import RateButton from './RateButton';

const EmojiOptions = [
  {
    rating: 'bad',
    ratingText: 'chat:::rateExpertBad',
  },
  {
    rating: 'average',
    ratingText: 'chat:::rateExpertPartial',
  },
  {
    rating: 'good',
    ratingText: 'chat:::rateExpertGood',
  },
];

const EmojiRateExpert = function ({
  selectedRating,
  chatId,
  width = 30,
  onSubmit = () => {},
  eventLabel = 'Pre Rated',
  showEmojiText = false,
}) {
  const [currentRating, setCurrentRating] = useState(selectedRating);
  const [preRateChat] = useMutation(RATE_EXPERT);
  const { t } = useTranslation();

  useEffect(() => {
    setCurrentRating(selectedRating);
  }, [selectedRating]);

  const handleRateSelection = (rating) => {
    if (rating === currentRating) return;
    setCurrentRating(rating);
    events.preRateExpert(`${eventLabel}: ${rating}`);
    preRateChat({ variables: { id: chatId, rating } });
    onSubmit();
  };

  return (
    <Row align="bottom">
      <Space orientation="horizontal" size={4}>
        {EmojiOptions.map(({ rating, ratingText }) => (
          <RateButton
            key={rating}
            $selected={!currentRating || rating === currentRating}
            $rating={rating}
            onClick={() => handleRateSelection(rating)}
          >
            <Space orientation="vertical" size={10} align="center">
              <Emoji
                type={rating}
                width={rating === currentRating ? width : width - 2}
              />
              {showEmojiText && t(ratingText)}
            </Space>
          </RateButton>
        ))}
      </Space>
    </Row>
  );
};

EmojiRateExpert.propTypes = {
  chatId: PropTypes.string.isRequired,
  selectedRating: PropTypes.string,
  eventLabel: PropTypes.string,
  onSubmit: PropTypes.func,
  width: PropTypes.number,
  showEmojiText: PropTypes.bool,
};

export default EmojiRateExpert;
